import React from 'react'

import theme from 'theme'

const SmallSquareButton: React.FC<{
  isSelected: boolean
  isStatic: boolean
  disabled?: boolean
  onClick?(event: any): void
}> = ({ isSelected, isStatic, ...rest }) => {
  return (
    <button
      css={[
        {
          border: 0,
          outline: 'none',
          color: isSelected ? theme.colors.white[0] : theme.colors.steel[1],
          fontSize: theme.fontSizes[0],
          fontWeight: theme.fontWeights[1],
          height: theme.space[5],
          width: theme.space[5],
          borderRadius: theme.borderRadius[0],
          backgroundColor: isSelected
            ? theme.colors.steel[2]
            : theme.colors.gray[1]
        },

        !isStatic && {
          cursor: 'pointer',

          '&:hover': {
            color: theme.colors.white[0],
            backgroundColor: theme.colors.steel[2]
          }
        }
      ]}
      type="button"
      {...rest}
    />
  )
}

export default SmallSquareButton
